import React from 'react';
import PropTypes from 'prop-types';
import { PopoverItem } from 'site-modules/shared/components/popover-item/popover-item';

export const ArticleTableTooltip = ({ className = '', descriptionText = '' }) => (
  <PopoverItem
    iconClassName="medium"
    innerClassName="px-0_75 py-0_5 text-cool-gray-30"
    className={`${className} article-table-tooltip d-inline-flex`}
    trigger="hover focus"
    screenReaderTooltipLabel={descriptionText}
  >
    {descriptionText}
  </PopoverItem>
);

ArticleTableTooltip.propTypes = {
  className: PropTypes.string,
  descriptionText: PropTypes.string,
};
